<div class="modal-wrapper">
  <div class="modal-header">
    <h4 class="modal-title">Exclude companies based on Shareholder Ownership validation</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body no-scroll"> 
    <div class="row mt-4">
      <div class="col-12">
        <div>
          <div class="select-type-selection-header">
            Validate based on
          </div>
        </div>
      </div>
      <div class="study-rd-btn ms-3 d-inline-block">
        <div class="d-inline-block study-rd-btn ms-1">
          <div class="usrDefined">
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio"
                     id="ShareholderNameBtn"
                     name="ShareholderSelectionOptions"
                     class="custom-control-input"
                     [(ngModel)]="shareholderIndependencyCriteria"
                     [value]="1"
                     (change)="shareholderIndependencyCriteriaChange()"
                     #FilingType="ngModel"
                     required />
              <label class="custom-control-label form-check-label" for="ShareholderNameBtn">Shareholder Name </label>
            </div>
          </div>
          <div class="usrDefined">
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio"
                     id="ShareholderNameIdBtn"
                     name="ShareholderSelectionOptions"
                     class="custom-control-input"
                     [(ngModel)]="shareholderIndependencyCriteria"
                     [value]="2"
                     (change)="shareholderIndependencyCriteriaChange()"
                     #FilingType="ngModel"
                     required />
              <label class="custom-control-label form-check-label" for="ShareholderNameIdBtn">Shareholder Name & ID</label>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 select-type-selection-body mb-1 mt-4 section">
        <div class="col-12 select-type-selection-header mb-1">
          <span>Independency Threshold (%)</span>
        </div>
        <div class="col-4 d-inline-block">
          <div class="form-group">
            <span class="ey-float-label" title="Enter a Shareholder Independency Threshold">
              <input type="number"
                     class="form-control"
                     id="shareholderIndependencyThresholdid"
                     name="shareholderIndependencyThresholdid"
                     [(ngModel)]="shareholderIndependencyThreshold"
                     min="1" max="100"
                     required
                     (blur)="validateSave()"
                     (input)="validateSave()"
                     appLabelFloat />
            </span>
          </div>
        </div>
      </div>
      <div class="col-12 select-type-selection-body mb-1 mt-4 section">
        <div class="col-12 select-type-selection-header mb-1 centeralignment">
          <span class="custom-control-label form-check-label bold">
            If an individual shareholder owns more than the specified above percentage of a company available in the study set, and also holds more than that percentage in any other company, the company in the study set will be rejected.
          </span>
        </div>
      </div>
      <div *ngIf="showValidationMessage" class="validationMessage">
        <span class="help-block">
          {{ validationMessage }}
        </span>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="close()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="save()">Save</button>
  </div>
</div>
